<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block" style="display:flex">
          <el-input placeholder="咨询主题" style="width: 200px" v-model="searchObj.title" clearable></el-input>
          <el-select style="margin-left: 20px" filterable clearable v-model="searchObj.company_id" placeholder="企业名称">
            <el-option
              v-for="item in companyArr"
              :key="item.id"
              :label="item.company_name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select style="margin-left: 20px" filterable clearable v-model="searchObj.country_id" placeholder="所在国家">
            <el-option
              v-for="item in countryArr"
              :key="item.id"
              :label="item.area_name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select style="margin-left: 20px" filterable clearable v-model="searchObj.category" placeholder="事件类型">
            <el-option
              v-for="item in categoryArr"
              :key="item.label"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
          <el-select style="margin-left: 20px" filterable clearable v-model="searchObj.is_reply" placeholder="回复状态">
            <el-option
              v-for="item in replyArr"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select style="margin-left: 20px" filterable clearable v-model="searchObj.user_id" placeholder="操作人">
            <el-option
              v-for="item in memberArr"
              :key="item.id"
              :label="item.username"
              :value="item.id">
            </el-option>
          </el-select>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData">查询</el-button>
          </el-row>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="title" label="咨询主题" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="company_name" label="企业名称" min-width="100"></el-table-column>
        <el-table-column prop="full_area_name" label="所在国家地区" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="category" label="事件类型" min-width="120"></el-table-column>
        <el-table-column prop="level" label="紧急程度">
          <template slot-scope="scope">
            <span>{{scope.row.level == 1 ? '一般':scope.row.level == 2 ? '紧急':'十分紧急'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="相关单位"></el-table-column>
        <el-table-column prop="update_time" label="上报时间" min-width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.update_time) || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_reply" label="回复状态">
          <template slot-scope="scope">
            <span>{{scope.row.is_reply == 1 ? '已回复':'未回复'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reply_time" label="最后回复时间" min-width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.reply_time) || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="last_operate_user_name" min-width="100" label="操作人">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" size="small" @click="settingsFn(scope.row)">
                回复
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"
import tokenService from "@/utils/services/token_service";
export default {
  mixins: [timestampToTime],
  name: "CountryBase",
  data() {
    return {
      searchObj: {
        title: '',
        company_id: '',
        country_id: '',
        category: '',
        is_reply: '',
        user_id: ''
      },
      tableData: [],
      companyArr: [], //企业名称下拉菜单
      countryArr: [], //国家下拉菜单
      categoryArr: [
        {label: '恐怖主义'},
        {label: '政治风险'},
        {label: '战争及武装冲突'},
        {label: '群体事件'},
        {label: '疾病疫情'},
        {label: '社会治安'},
        {label: '自然灾害'},
        {label: '事故灾难'},
        {label: '民族矛盾及部落冲突'},
        {label: '经济事件'},
        {label: '难民事件'},
        {label: '国际关系事件'}
      ],
      replyArr: [
        {id: 1, label: '已回复'},
        {id: 2, label: '未回复'}
      ],
      memberArr: [], //操作人下拉菜单
      currentPage: 1,
      totalList: null,
    };
  },
  created() {
    this.getData()
    this.companyArrFn()
    this.countryArrFn()
    this.memberArrFn()
  },
  methods: {
    // 获取数据
    getData(data) {
      api
        .inquiryList(data)
        .then(res => {
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
        })
        .catch(err => {
          this.$message(err);
        });
    },

    clearParam(param) {
      if(this.searchObj[param] == '') {
        delete this.searchObj[param]
      }
    },

    // 查询
    queryData() {
      this.clearParam('title')
      this.clearParam('company_id')
      this.clearParam('country_id')
      this.clearParam('is_reply')
      this.clearParam('category')
      this.clearParam('user_id')
      this.searchObj.page = 1
      this.currentPage = 1
      this.getData(this.searchObj)
    },
    handleCurrentChange(val){
      this.currentPage = val
      let datas = {
        page: this.currentPage
      }
      this.getData(datas)
    },
    // 企业下拉菜单
    companyArrFn() {
      api
        .govList({
          pagesize: 999
        })
        .then(res => {
          this.companyArr = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },
    // 国家下拉菜单
    countryArrFn() {
      api
        .adminAreaList({
          pagesize: 9999,
          area_type: 2
        })
        .then(res => {
          this.countryArr = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 操作人下拉菜单
    memberArrFn() {
      api
        .memberList({
          pagesize: 9999,
        })
        .then(res => {
          this.memberArr = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 编辑操作
    settingsFn(row) {
      let routeData = this.$router.resolve({
        name: "add_consultation",
        query: {
          id: row.id
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>